<div class='full-form'>
  <language-select
    [selected]='appService.language.value'
    (changed)='appService.language.next($event)'
    [languageCodes]='appService.supportedLanguageCodes'
  [activeLanguageCodes]='datasetMCS.activeLanguageCodes'></language-select>

  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  @if (datasetACS.ready.value) {
    <div class='mt-24'>
      @if (!datasetRS.record.value && !datasetACS.loading.value) {
        <p>{{'Questa traduzione non è presente!' | translate}}</p>
      }
      @if (datasetRS.record.value) {
        <data-container-viewer
          [dataContainerService]='datasetACS'
          [fields]='stepConfig.options.fields'
          [record]='datasetRS.record.value'
        ></data-container-viewer>
      }
    </div>
  }
</div>